import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	addPeopleButtonLabel: {
		id: 'ptc-directory.add-people.button',
		defaultMessage: 'Add people',
		description: 'The text on the button that opens the Add People modal',
	},
});
